import AxiosClient from '../../utils/AxiosClient';
import logAxiosError from '../../utils/logAxiosError';
import { useState } from 'react';
import { SearchFilters } from '@th/shared/src/types/SearchFilters';
import { Place } from '@th/shared/src/types/Place';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';

type PlaceResult = {
  place: Place;
  listing: undefined;
  searchFilters: undefined;
};

type ListingResult = {
  place: undefined;
  listing: SimpleListing;
  searchFilters: undefined;
};

type NlpSearchFiltersResult = {
  place: undefined;
  listing: undefined;
  searchFilters: SearchFilters;
};

export default function useLazyFetchSearchGeneralByPhrase(): [
  (
    phrase: string,
  ) => Promise<PlaceResult | ListingResult | NlpSearchFiltersResult>,
  {
    isLoading: boolean;
  },
] {
  const [isLoading, setIsLoading] = useState(false);

  async function fetch(phrase: string) {
    setIsLoading(true);

    const endpoint = `/api/v1/search?q=${encodeURIComponent(phrase)}`;
    try {
      const result = await AxiosClient.get(endpoint);
      const data = result.data;

      if (data.place) {
        return { place: Place.fromObject(data.place) };
      } else if (data.listing) {
        return { listing: SimpleListing.fromObject(data.listing) };
      } else {
        return data;
      }
      setIsLoading(false);
    } catch (err) {
      logAxiosError(`useLazyFetchSearchGeneralByPhrase GET ${endpoint}`, err);
      setIsLoading(false);
      return {};
    }
  }

  return [fetch, { isLoading }];
}
